import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import Notification from "../../../components/common/notification/Notification";

interface AlertLogsProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  setIsValid?: any;
  setAlertModelShow?: any;
  // submitHandler?: () => void;
}

const AlertLogs: React.FC<AlertLogsProps> = ({
  open,
  title,
  onHide = () => {},
  content,
  setIsValid,
  isError,setAlertModelShow
  // submitHandler = () => {}
}) => {
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

  const submitHandler = () => {
    setIsValid(true);
    setAlertModelShow(false);
  };
  return (
    <Popup
      open={open}
      title={title || "Alert"}
      onHide={onHide}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isError ? (
            <CustomButton variant="outlined" title="Close" onClick={onHide} />
          ) : (
            <>
              <CustomButton variant="outlined" title="Cancel" onClick={onHide} />
              <CustomButton title="Continue" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              This is not the correct way.
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertLogs;
